<template>
    <v-card :class="`uti-detail-card ${utiCarro.remainOnBoardScarico ? 'uti-rob' : ''}`"
        :style="`background:${getUtiStateColor(utiCarro)};`">

        <v-card-text class="pa-3">
            <div class="d-flex align-center justify-space-between">
                <div>
                    <div class="font-weight-black">{{ codice }}</div>
                    <div class="text-uppercase text-caption">{{ stato }}</div>
                </div>
            </div>
            <div class="d-flex align-center gap-1">
                <div v-if="showTonsText(utiCarro)" class="text-caption font-weight-black ml-auto">{{ getTonsText() }}
                </div>
                <div v-else-if="features.length > 0" class="ml-auto" style="width: 13px; height: 13px;"
                    :class="getFeatureIcon(utiCarro).bgcolor">
                    <v-icon :color="getFeatureIcon(utiCarro).color" size="13">{{ getFeatureIcon(utiCarro).icon
                        }}</v-icon>
                </div>
            </div><br>

            <v-divider></v-divider>
            <div class="mt-2 mb-2 d-flex flex-column">
                <v-icon class="mr-auto" size="18">mdi-information</v-icon>
                <div>
                    <span class="font-weight-bold">{{ $t('type') }}:</span> {{ tipo }}
                </div>
            </div>
            <v-divider></v-divider>
            <div class="mt-2">
                <div class="d-flex flex-column mb-1">
                    <v-icon class="mr-auto" size="18">mdi-tape-measure</v-icon>
                    <div>
                        <span class="font-weight-bold">{{ $t('weight') }}:</span> {{ peso }} {{ $t('kg') }}
                    </div>
                    <div>
                        <span class="font-weight-bold">{{ $t('dimension') }}:</span> {{ lunghezza }} {{ $t('ft') }}
                    </div>
                    <div v-if="numeroColli">
                        <span class="font-weight-bold">{{ $t('package') }}:</span> {{ numeroColli }}
                    </div>
                </div>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>
import convoyVisualizationMixins from './mixins/convoyVisualizationMixins'

export default {
    name: "wagonDialogUtiDetails",
    mixins: [convoyVisualizationMixins],
    props: {
        utiCarro: {
            type: Object,
            required: true
        },
        features: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        showTonsText(utiCarro) {
            return this.features.includes("TON") && utiCarro.visitaUti.pesoLordo > 29000;
        },
        getFeatureIcon(utiCarro) {
            var featsIcons = [];
            let isPericoloso = false;
            if (this.features.includes("IMO")) {
                /* anche in altri punti del rail vince l'informazione su uti, anche se nulla*/
                // console.log("dangerousIndicator", utiCarro.visitaUti.id, utiCarro.visitaUti.dangerousIndicator);
                if (!!utiCarro.visitaUti.dangerousIndicator) {
                    isPericoloso = utiCarro.visitaUti.dangerousIndicator;
                } else if (utiCarro.visitaUti.uti) {
                    isPericoloso = !!utiCarro.visitaUti.uti.pericoloso;
                } else if (utiCarro.visitaUti.tipoUti) {
                    isPericoloso = !!utiCarro.visitaUti.tipoUti.pericoloso;
                }
            }
            if (isPericoloso) {
                featsIcons.push({ icon: "mdi-rhombus", color: "error", bgcolor: null });
            }

            let isReefer = false;
            if (this.features.includes("REE")) {
                // console.log("operationalReefer", utiCarro.visitaUti.id, utiCarro.visitaUti.operationalReefer);
                if (!!utiCarro.visitaUti.operationalReefer) {
                    isReefer = utiCarro.visitaUti.operationalReefer;
                } else if (utiCarro.visitaUti.uti) {
                    isReefer = !!utiCarro.visitaUti.uti.reefer;
                } else if (utiCarro.visitaUti.tipoUti) {
                    isReefer = !!utiCarro.visitaUti.tipoUti.reefer;
                }
            }
            if (isReefer) {
                featsIcons.push({ icon: "mdi-snowflake", color: "white", bgcolor: "light-blue lighten-1" });
            }

            if (featsIcons.length > 1) {
                featsIcons = [{ icon: "mdi-checkbox-multiple-blank-outline", color: "black", bgcolor: null }];
            }

            var featsIcon = featsIcons.length > 0 ? featsIcons[0] : { icon: "", color: "white", bgcolor: null };
            // console.log("featsIcon ------- ", featsIcon.icon, featsIcon.color);
            return featsIcon;
        },
    },
    computed: {
        codice() {
            return this.getUtiCode(this.utiCarro);
        },
        tipo() {
            return this.getUtiType(this.utiCarro);
        },
        peso() {
            return this.getUtiWeight(this.utiCarro);
        },
        lunghezza() {
            return this.getUtiLength(this.utiCarro);
        },
        pericoloso() {
            return this.getUtiDangerousFlag(this.utiCarro);
        },
        stato() {
            const statusObj = this.$config.rails.utiWagonStates[this.utiCarro.tipoMovimento.toLowerCase()][this.utiCarro.stato.toLowerCase()];
            return statusObj ? statusObj.status : '';
        },
        numeroColli() {
            return this.getUtiNumber(this.utiCarro);
        }
    }
}
</script>

<style scoped>
.uti-detail-card {
    background: rgb(204, 191, 191)
}

.uti-rob {
    background-image: repeating-linear-gradient(-45deg,
            #ffffff,
            #ffffff 10px,
            rgb(196, 196, 192) 10px,
            rgb(196, 196, 192) 20px) !important;
}

.uti-detail-danger-icon {
    color: red;
}

.uti-detail-actions {
    width: 100%;
    text-align: right;
}
</style>